import { storyblokEditable } from '@storyblok/react';
import { motion } from 'framer-motion';
import { FC } from 'react';

import Container from '@/components/elements/Container';
import Prose from '@/components/elements/Prose';
import Section from '@/components/elements/Section';

export interface TwoColumnRichTextProps {
  blok: any;
}

const TwoColumnRichText: FC<TwoColumnRichTextProps> = ({ blok }) => {
  return (
    <Section {...storyblokEditable(blok)} className="overflow-hidden">
      <Container
        size={'widest'}
        className="grid gap-8 align-middle md:grid-cols-2"
      >
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
            },
          }}
          viewport={{ once: true, margin: '200px' }}
          className="self-center"
        >
          {blok.ColumnA && <Prose size={'base'} content={blok.ColumnA}></Prose>}
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.5,
            },
          }}
          viewport={{ once: true, margin: '200px' }}
          className="self-center"
        >
          {blok.ColumnB && <Prose size={'base'} content={blok.ColumnB}></Prose>}
        </motion.div>
      </Container>
    </Section>
  );
};

export default TwoColumnRichText;
